import { memo,useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import { BzButton, BzModal, BzModalBody, BzModalFooter, BzModalHeader } from '../../components'
import {APP_INFO_PARAMS} from "../../utils/global_variables"
import { handleModal } from '../../redux/actions/modals';
import { getAppInfoData } from '../../utils/global_functions';
import { getDyanmicURL } from '../../utils/global_functions';
import { LINK_OPEN_MODES } from '../../utils/global_variables';
import { updateInAppIFrame } from '../../redux/actions/appInfo';

const CloseAccountModal = () => {

/*SAT_BT-109047_Breeze-User Profile --start */
    const initialContent = () => {
        return {
            body: 'Are you sure you want to Close Account?',
            buttonOne: 'Confirm',
            buttonTwo: 'Cancel',
        }
    }  
    /*SAT_BT-109047_Breeze-User Profile --end */

    const modals = useSelector(state => state?.modals?.modals);
    const dispatch = useDispatch()
    const { appInfo } = useSelector(state => state.appInfo);
    const {objLoginSession} = useSelector(state => state.auth)
    const [modalContent, setModalContent] = useState(initialContent())


    /*SAT_BT-109047_Breeze-User Profile --start */
    const handleHide = () => {
        setModalContent(initialContent())
        dispatch(handleModal([{ "CLOSE_ACCOUNT_MODAL": false }]));
    };
    /*SAT_BT-109047_Breeze-User Profile --end */


    /*SAT_BT-109047_Breeze-User Profile --start */
    const closeAccount = ()=>{
            const data = getAppInfoData(APP_INFO_PARAMS.APP_EKYC_INFO, appInfo);
            if(data?.reekycurl){
                let ekycUrl = getDyanmicURL({ url: data?.reekycurl }, objLoginSession)
                ekycUrl = ekycUrl.replace('{{REQUESTTYPE}}', 'C');
                if (data?.openmode === LINK_OPEN_MODES.IFRAME) {
                    dispatch(updateInAppIFrame({ url: ekycUrl, title: 'Close Account' }));
                    dispatch(handleModal([{ "IN_APP_IFRAME": true }]));
                }
                else {
                    window.open(ekycUrl)
                }
                handleHide()
            }else{
                setModalContent({
                    body: 'Kindly contact your Broker for Account Closure',
                    buttonTwo: 'OK',
                    style:true
                })
            }     
    }
    /*SAT_BT-109047_Breeze-User Profile --end */

    return (
        <BzModal size="sm" show={modals['CLOSE_ACCOUNT_MODAL']} onHide={handleHide}>
        <BzModalHeader className='modaltabs-header' closeButton>
            <Container fluid className='p-0'>
                <Row className='g-0'>
                    <Col className='d-flex justify-content-start align-items-center'>
                        <div className='font-medium font-size4 color-text'>Close Account</div>
                    </Col>
                </Row>
            </Container>
        </BzModalHeader>
        <BzModalBody>
            <Container fluid className='p-0'>
                <Row className='g-0'>
                    <Col className='d-flex justify-content-start'>
                        <div className='font-regular font-size4 color-text'>{modalContent?.body}</div>
                    </Col>
                </Row>
            </Container>
        </BzModalBody>
        <BzModalFooter>
            <Container fluid className='p-0 m-0'>
                <Row className='g-0 justify-content-end align-items-center'>
                    {
                        modalContent?.buttonTwo ? <Col md='auto'>
                            <BzButton className={modalContent.style ? 'btn btn-md btn-primary' : 'btn btn-md btn-outline me-3'} onClick={handleHide}>{modalContent?.buttonTwo}</BzButton>
                        </Col> : null
                    }
                    {modalContent?.buttonOne ? <Col md='auto'>
                        <BzButton className='btn btn-md btn-primary' onClick={closeAccount}>{modalContent?.buttonOne}</BzButton>
                    </Col> : null}
                </Row>
            </Container>
        </BzModalFooter>
    </BzModal>
)
}

export default memo(CloseAccountModal)